import { PATHS } from '../const/paths.constants';
import { IQuery, IRequestQuery } from '../interfaces/queries.interface';
import { API } from './config-service.api';

export const getRequests = async <T>(query: IQuery): Promise<T> => {
    const url = PATHS.REQUESTS;
    const response = await API.get<T>(url, {
        params: query,
        paramsSerializer: {
            indexes: null,
        },
    });
    return response.data;
};

export const getRequestSearch = async <T>(id: string, params: IRequestQuery): Promise<T> => {
    const url = `${PATHS.REQUESTS}/${id}/search`;
    const response = await API.get<T>(url, {
        params,
        paramsSerializer: {
            indexes: null,
        },
    });
    return response.data;
};
